module.exports = __webpack_public_path__ + "img/payment.c724a92a.svg";